import {
  Component, DestroyRef,
  EventEmitter, inject,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { MatSelectChange } from "@angular/material/select";
import { LorenPeriod } from "../../interfaces/loren-period.interface";
import { LorenPeriodSelectorService } from "../../services/loren-period-selector-service/loren-period-selector.service";
import { LorenBreakpointObserverService } from "../../../../services/loren-breakpoint-observer-service/loren-breakpoint-observer.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "loren-period-selector",
    templateUrl: "./loren-period-selector.component.html",
    styleUrls: ["./loren-period-selector.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenPeriodSelectorComponent implements OnInit {
  private breakpointObserverService = inject(LorenBreakpointObserverService);

  private readonly destroyRef = inject(DestroyRef);
  @Input() look: string;
  @Output() periodChange = new EventEmitter<LorenPeriod>();

  periods = LorenPeriodSelectorService.getPeriods();
  lastSelectedPeriod: LorenPeriod;
  isHandset: boolean;

  ngOnInit(): void {
    this.breakpointObserverService
      .getHandsetStateSubscription()
      .pipe(
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((x) => (this.isHandset = x));

    this.periodChange.emit(this.periods[0]);
  }

  onSelectionChange($event: MatSelectChange) {
    const period = $event.value as LorenPeriod;
    this.lastSelectedPeriod = period;
    this.periodChange.emit(period);
  }
}
